import CategoriesItemList from 'components/CategoriesItemList/CategoriesItemList';
import { useSelector } from 'react-redux';
import { selectModalCamper } from '../../redux/selectors';
import css from './Features.module.css';

const Features = () => {
  const camper = useSelector(selectModalCamper);

  if (!camper) {
    return null;
  }

  const { adults, details, form, length, width, height, tank, consumption } =
    camper;
  const {
    airConditioner,
    microwave,
    freezer,
    toilet,
    TV,
    CD,
    radio,
    shower,
    hob,
    gas,
  } = details;

  return (
    <div className={css['container-features']}>
      <div>
        <CategoriesItemList
          adults={adults}
          airConditioner={airConditioner}
          microwave={microwave}
          freezer={freezer}
          toilet={toilet}
          TV={TV}
          CD={CD}
          radio={radio}
          shower={shower}
          hob={hob}
          gas={gas}
        />
      </div>
      <div>
        <h2 className={css['title']}>Vehicle details</h2>
        <div className={css['navigation-line']}></div>
        <div className={css['text-info']}>
          <p>Form</p>
          <p className={css['capitalize']}>{form}</p>
        </div>
        <div className={css['text-info']}>
          <p>Length</p>
          <p>{length}</p>
        </div>
        <div className={css['text-info']}>
          <p>Width</p>
          <p>{width}</p>
        </div>
        <div className={css['text-info']}>
          <p>Height</p>
          <p>{height}</p>
        </div>
        <div className={css['text-info']}>
          <p>Tank</p>
          <p>{tank}</p>
        </div>
        <div className={css['text-info']}>
          <p>Gas</p>
          {gas ? <p>{gas}</p> : <p>---</p>}
        </div>
        <div className={css['text-info']}>
          <p>Consumption</p>
          <p>{consumption}</p>
        </div>
      </div>
    </div>
  );
};

export default Features;
